/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Credit_Control_Step_Not_RecordableInputs */

const en_error_credit_control_step_not_recordable = /** @type {(inputs: Error_Credit_Control_Step_Not_RecordableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This step of Credit Control does not apply here.`)
};

/**
* | output |
* | --- |
* | "This step of Credit Control does not apply here." |
*
* @param {Error_Credit_Control_Step_Not_RecordableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_credit_control_step_not_recordable = /** @type {((inputs?: Error_Credit_Control_Step_Not_RecordableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Credit_Control_Step_Not_RecordableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_credit_control_step_not_recordable(inputs)
});